<template>
  <div class="container-news">
    <h2 class="news-title"><router-link :to="{ name: $t('newsRouteName'), params: { id: getNewsId } }">{{
      $t("news") }}</router-link></h2>
    <div class="carousel-container">
      <button id="previous-news-btn" class="news-btn previous-news-btn" @click="scrollCarousel(-1)">
        <i class="fa fa-chevron-left"></i>
      </button>
      <div class="carousel-view">
        <div id="item-list" class="item-list">
          <div v-for="item in getHighlightedNews" :key="item.id" class="news-article">
            <app-highlighted-news-card :id="item.id"></app-highlighted-news-card>
          </div>
        </div>
      </div>
      <button id="next-news-btn" class="news-btn next-news-btn" @click="scrollCarousel(1)">
        <i class="fa fa-chevron-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import HighlightedServicesCard from './HighlightedNewsCard.vue'

export default {
  data() {
    return {
      htmlContent: ""
    }
  },
  computed: {
    ...mapGetters(["getHighlightedNews"]),
    hasHiglightedNews() {
      return this.getHighlightedNews.length > 0;
    },
  },
  components: {
    appHighlightedNewsCard: HighlightedServicesCard
  },
  methods: {
    ...mapActions(["fetchContentById"]),
    loadData() {
      this.fetchContentById(this.id).then((contentResposnse) => {
        this.htmlContent = contentResposnse.content;
      });
    },
    scrollCarousel(direction) {
      const container = this.$el.querySelector("#item-list");
      const element = this.$el.querySelector(".news-article");
      const width = element.getBoundingClientRect().width + 45; // Add gap between items
      container.scrollLeft += direction * width; // Scroll by width of each element
    },
    getNewsId() {
      if (this.getHighlightedNews.length > 0) {
        return this.getHighlightedNews[0].parentId;
      }
      return 0;
    }
  },
  created() {
    this.getNewsId();
  },
  mounted() {
    const prevServicesFirst = this.$el.querySelector('#previous-news-btn');
    const nextServicesFirst = this.$el.querySelector('#next-news-btn');
    prevServicesFirst.addEventListener('click', () => {
      this.scrollCarousel(-1);
    });
    nextServicesFirst.addEventListener('click', () => {
      this.scrollCarousel(1);
    });
  },
  watch: {
    content() {
      this.loadData();
    }
  },
}
</script>

<style scoped>
.news {
  background-color:  var(--secondary-color);
  padding: 5% 7% 2% 7%;
}

.news-title {
  color: var(--main-color);
  margin-bottom: 2rem;
  font-size: 30px;
  font-weight: 600;
  cursor: pointer;
}

.news-title a {
  text-decoration: none;
  color: var(--main-color);
}

.news-title a:hover {
  text-decoration: none;
}

.carousel-container {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.news-article {
  border-radius: 15px;
  background-color: var(--light-color);
  padding: 1%;
  width: calc((100% - 90px)/3);
  scroll-snap-align: center;
  min-width: calc((100% - 90px)/3);
}

.container-news {
  width: 100%;
  padding: 20px 7%;
  display: block;
  justify-content: center;
  align-items: center;
  background-color:  var(--secondary-color);
}

.carousel-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.25s ease-in;
  width: 100%;
  overflow: hidden;
  padding: 0 10px;
}

.carousel-view .item-list {
  width: 100%;
  display: flex;
  gap: 45px;
  scroll-behavior: smooth;
  transition: all 0.25s ease-in;
  -ms-overflow-style: none;
  scrollbar-width: none;
  overflow: hidden;
}

.item-list::-webkit-scrollbar {
  display: none;
}

.news-btn {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  /* background: linear-gradient(152deg, rgba(2, 0, 36, 1) 0%, rgba(36, 59, 128, 1) 45%); */
  background-color:  var(--secondary-color);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  color: var(--main-color);
  position: relative;
  font-size: 25px;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease;
  padding: 0;
  line-height: 0;
}

.news-btn i {
  display: flex; /* Make the icon itself a flex container */
  justify-content: center;
  align-items: center;
  height: 100%; /* Take up full height of the button */
  width: 100%; /* Take up full width of the button */
  margin: 0; /* Remove any margins */
}

.news-btn i.fa-chevron-left {
  transform: translateX(-2px); /* Slight adjustment for left arrow if needed */
}

.news-btn i.fa-chevron-right {
  transform: translateX(2px); /* Slight adjustment for right arrow if needed */
}

.news-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.previous-news-btn {
  margin-right: -25px;
}

.next-news-btn {
  margin-left: -25px;
}

@media only screen and (max-width: 1200px) {
  .news-article {
    width: calc((100% - 45px)/2);
    min-width: calc((100% - 45px)/2);
  }
  
  .news-btn {
    width: 44px;
    height: 44px;
  }
}

@media only screen and (max-width: 768px) {
  .news-article {
    width: calc(100% - 90px);
    min-width: calc(100% - 90px);
  }
  
  /* For very small screens, adjust button positions */
  .carousel-container {
    padding: 0 20px;
  }
  
  .previous-news-btn {
    margin-right: -15px;
  }
  
  .next-news-btn {
    margin-left: -15px;
  }
}

@media (max-width: 480px) {
  .news-article {
    width: 100%;
    min-width: 100%;
  }
}
</style>
